




















$ = require 'jquery'

import SpinningCube from '@/components/SpinningCube'
import StoreLinks from '@/components/StoreLinks'
import GeotapLogo from '@/components/GeotapLogo'

export default {
  name: 'marquee'
  
  data: -> ready: false 

  components: 
    'spinning-cube': SpinningCube
    'store-links': StoreLinks
    'geotap-logo': GeotapLogo

  beforeMount: ->
    setTimeout @buildin, 200

  methods: 
    # Scroll down to the next main section
    onDownArrowClick: ->
      $('html, body').animate({ scrollTop: $(".lucre-laurels").offset().top - 50, easing: 'swing' }, 1600); 

    buildin: ->
      @ready = true
      console.log 'build in', @ready
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Marquee.vue